import { render, staticRenderFns } from "./NoDataDialog.vue?vue&type=template&id=55f953bf"
import script from "./NoDataDialog.vue?vue&type=script&lang=js"
export * from "./NoDataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports